export function productDraft(product) {
  const n = product.nutriments || {};
  const number = value => value !== undefined && value !== null && value !== '' && Number.isFinite(Number(value)) && Number(value) >= 0 ? Number(value) : '';
  const kcal = number(n['energy-kcal_100g']);
  const kj = number(n['energy-kj_100g']);
  return { name: product.product_name_es || product.product_name || '', cal: kcal !== '' ? kcal : kj !== '' ? Math.round(kj / 4.184 * 10) / 10 : '', prot: number(n.proteins_100g), carbs: number(n.carbohydrates_100g), fat: number(n.fat_100g) };
}
